'use client';

import cn from 'classnames';
import type { ReactNode } from 'react';
import { useToggle } from 'react-use';
import { Collapse } from 'transitions-kit';
import css from './fold.module.scss';

type Props = {
    children: ReactNode;
};
export function Fold({ children }: Props) {
    const [open, toggle] = useToggle(false);

    return (
        <div className={cn('devtools', css.devtool)}>
            <Collapse in={open} mountOnEnter unmountOnExit>
                <div className={css.content}>{children}</div>
            </Collapse>
            <button type="button" className={cn(css.icon, { [css.open]: open })} onClick={toggle}>
                <span>⚙︎</span>
            </button>
        </div>
    );
}
